import Image from "next/image";

import { GrainOverlay } from "@/components/ui/grain-overlay";
import { cn } from "@/lib/utils";

/** Figma Gradient - Blue (10413:57926) for careers nav preview shell. */
const CAREERS_BASE = "rgb(229, 242, 255)";

export function NavPreviewCareersGradientBackground() {
  return (
    <>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 z-0 overflow-hidden bg-[rgb(229,242,255)]"
      >
        <div
          className="absolute inset-0 bg-size-[312.5364685058594px_312.5364685058594px] bg-top-left bg-no-repeat"
          style={{
            backgroundImage: `url(/assets-next/partners/platform-partners/gradient-blue-texture.png), linear-gradient(90deg, ${CAREERS_BASE} 0%, ${CAREERS_BASE} 100%)`,
          }}
        >
          <CareersGradientEllipse
            className="top-[10.74px] left-[-118.89px] flex h-[798.596px] w-[859.415px] items-center justify-center"
            innerClassName="h-[559.493px] w-[686.501px] flex-none rotate-[-25.21deg]"
            insetClassName="inset-[-33.1%_-26.98%]"
            src="/assets-next/partners/platform-partners/gradient-ellipse-5127.svg"
          />
          <CareersGradientEllipse
            className="top-[-281.11px] left-[-7.41px] size-[522.222px]"
            insetClassName="inset-[-21.28%]"
            src="/assets-next/partners/platform-partners/gradient-ellipse-5129.svg"
          />
          <CareersGradientEllipse
            className="top-[-300px] left-[-286.3px] size-[522.222px]"
            insetClassName="inset-[-21.28%]"
            src="/assets-next/partners/platform-partners/gradient-ellipse-5128.svg"
          />
        </div>
      </div>
      <GrainOverlay
        baseFrequency={0.85}
        numOctaves={2}
        contrast={1.8}
        opacity={0.28}
        blendMode="soft-light"
      />
    </>
  );
}

function CareersGradientEllipse({
  className,
  innerClassName,
  insetClassName,
  src,
}: {
  className: string;
  innerClassName?: string;
  insetClassName: string;
  src: string;
}) {
  const content = (
    <div className={cn("absolute", insetClassName)}>
      <Image
        src={src}
        alt=""
        fill
        unoptimized
        className="max-w-none object-fill"
      />
    </div>
  );

  if (innerClassName) {
    return (
      <div className={cn("pointer-events-none absolute", className)}>
        <div className={cn("relative", innerClassName)}>{content}</div>
      </div>
    );
  }

  return (
    <div className={cn("pointer-events-none absolute", className)}>
      <div className="relative size-full">{content}</div>
    </div>
  );
}
